import L from 'leaflet';

export function createVehicleIcon(color: string): L.DivIcon {
  return L.divIcon({
    className: 'custom-vehicle-marker',
    html: `<div style="
      width: 12px; height: 12px;
      background: ${color};
      border: 2px solid rgba(255,255,255,0.8);
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    "></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6],
  });
}

const CASETA_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="14" height="14"><path d="M2 20h2V8h2V6H4V4h4v2h2v2h2V6h4V4h4v2h-2v2h2v12h2v2H2v-2zm6 0h2v-6h4v6h2V8h-2V6h-4v2H8v12z"/><circle cx="14" cy="7" r="1.2" fill="white"/></svg>`;

const GAS_PUMP_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="14" height="14"><path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5z"/></svg>`;

export function createCasetaIcon(): L.DivIcon {
  return L.divIcon({
    className: 'caseta-marker',
    html: `<div style="
      width: 24px; height: 24px;
      background: #10b981;
      border: 2px solid white;
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.35);
    ">${CASETA_SVG}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
}

export function createGasolineraIcon(): L.DivIcon {
  return L.divIcon({
    className: 'gasolinera-marker',
    html: `<div style="
      width: 24px; height: 24px;
      background: #f59e0b;
      border: 2px solid white;
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.35);
    ">${GAS_PUMP_SVG}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
}

export function createDestinationIcon(): L.DivIcon {
  return L.divIcon({
    className: 'destination-marker',
    html: `<div style="
      width: 24px; height: 24px;
      background: #ef4444;
      border: 2px solid white;
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 12px; color: white;
      box-shadow: 0 3px 8px rgba(0,0,0,0.4);
      transform: rotate(-15deg);
    ">\uD83C\uDFF4</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
}

export function createRiskAlertIcon(color: string): L.DivIcon {
  return L.divIcon({
    className: 'risk-alert-marker',
    html: `<div style="
      width: 16px; height: 16px;
      background: ${color};
      border: 2px solid white;
      border-radius: 3px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    "></div>`,
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });
}
